import { Component, OnInit , ViewChild} from '@angular/core';
import { PricingService} from '../../services/pricing.service';
import { AuthService} from '../../../../../core/service/auth.service';
import { MessagingService} from '../../../../../core/service/messaging.service';
import  { EditPricingModalComponent} from '../../modals/edit-pricing-modal/edit-pricing-modal.component';
import { ModalService} from 'ngx-dynamic-modal'
import { PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import { AlertaService} from '../../../../../shared/services/alerta.service';


@Component({
  selector: 'app-list-pricing',
  templateUrl: './list-pricing.component.html',
  styleUrls: ['./list-pricing.component.scss']
})
export class ListPricingComponent implements OnInit {
    settings: Object;
    pricings: Array<any>;
    enabled: boolean;
    lastPortalSelected: number;
    searchItem:any;

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 3;

    @ViewChild (PaginationComponent) pagination: PaginationComponent;

    constructor(private pricingService:PricingService,
              private  auth: AuthService,
              private message: MessagingService,
              private  modalService: ModalService,
              private alerta:AlertaService ) {

    }

    ngOnInit() {

      this.pricings=[];
      this.lastPortalSelected=this.auth.getPkPortal();
      this.getPricingHistoryList({portal_pk:this.lastPortalSelected});
      this.message.message.subscribe(portal => {
          if(portal.hasOwnProperty('pkPortal') && portal.pkPortal !== this.lastPortalSelected) {
              this.lastPortalSelected = portal.pkPortal;
              this.getPricingHistoryList({portal_pk: this.lastPortalSelected});
          }
      });
    }

    getPricingHistoryList(criteria){
      this.enabled=true;
      this.pricingService.getPricingHistory(criteria)
          .subscribe( result => {
              this.pricings=result;
              this.endAt = (!this.haveToPaginate()) ? this.pricings.length : this.perPage;
              }, error => {
              console.log(error);
              }, () =>{
              this.enabled=false;
          })
    }

    openModal(element=null){
      this.modalService.addDynamicComponent(EditPricingModalComponent, {element}, (res) => {
          this.getPricingHistoryList({portal_pk:this.lastPortalSelected});
        });
    }

    haveToPaginate(): boolean {
        return this.perPage < this.pricings.length;
    }


    goToPage(n: number) {
        this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
    }

    deletePricing(pricing){
        this.alerta.addAlert('confirm','Do you want to Delete pricing?')
            .then((result)=>{
                if(result.value){
                    this.pricingService.removePricingHistory(pricing.pk)
                        .subscribe( result => {
                        }, error => {
                            console.log(error);
                            this.alerta.addAlert('error','Something went wrong!!')
                        }, () => {
                            this.alerta.addAlert('success','Pricing Deleted Succesfully!!')
                            let indx=this.pricings.indexOf(pricing);
                            this.pricings.splice(indx,1);
                            this.endAt = (!this.haveToPaginate()) ? this.pricings.length : this.perPage;
                        })}
            })
   }




}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/pricing/components/list-pricing/list-pricing.component.ts